<div id="payment-header-container" class="topbar">
  <img
    *ngIf="logoImageUrl"
    id="branding-logo"
    alt="Billtrust"
    src="{{ logoImageUrl }}"
  />

  <div class="header-right-controls">
    <payment-language-dropdown-container
      id="payment-language-dropdown"
    ></payment-language-dropdown-container>

    <button
      *ngIf="showSignInButton$ | async"
      id="header-sign-in-btn"
      aur-button
      importance="secondary"
      type="button"
      class="sign-in-button"
      (click)="onSignInClicked()"
    >
      Sign In
    </button>

    <span
      *ngIf="signedInFullName$ | async as fullName"
      id="header-signed-in-name"
      class="signed-in-name"
    >
      <i class="material-icons signed-in-icon">person_outline</i>
      <span>Signed in as<br />{{ fullName }}</span>
    </span>
  </div>
</div>
